'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCloseCircled = function IoCloseCircled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.6c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m8.4 23.3l-5.8-5.8 5.9-5.9c0.3-0.2 0.3-0.7 0-0.9l-1.7-1.7c-0.2-0.1-0.3-0.2-0.5-0.2s-0.2 0.1-0.4 0.2l-5.9 5.8-5.9-5.8c-0.2-0.1-0.3-0.2-0.4-0.2s-0.3 0.1-0.5 0.2l-1.6 1.7c-0.3 0.2-0.3 0.7 0 0.9l5.9 5.9-5.9 5.9c-0.2 0.1-0.2 0.3-0.2 0.4s0 0.3 0.2 0.5l1.6 1.7c0.2 0.2 0.3 0.2 0.5 0.2s0.3 0 0.4-0.2l5.9-5.9 5.9 5.8c0.2 0.2 0.3 0.3 0.4 0.3s0.3-0.1 0.5-0.3l1.6-1.6c0.2-0.1 0.3-0.3 0.3-0.5s-0.1-0.3-0.3-0.5z' })
        )
    );
};

exports.default = IoCloseCircled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/close-circled.js
// module id = 2227
// module chunks = 0